//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "dialog-select-message",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemLabelKey: {
      type: String,
      default: "message"
    },
    addNewLabel: {
      type: String,
      default: "Adicionar novo"
    },
    currentValue: {
      type: String,
      default: ""
    }
  },
  methods: {
    isActive: function isActive(item) {
      return !!this.currentValue && item[this.itemLabelKey] === this.currentValue;
    }
  }
};